import React from 'react';

import { Typography } from '@material-ui/core';
import { SelectField, Step } from '../SteppedForm';

const StepSales = (props) => {
  return (
    <Step id="sales" title="Sales Person">
      <Typography variant="body1" class="formQuestion">
        Please let us know if a member of the 13cabs Operator Sales Team referred you to 13cabs or
        assisted you with your application?
      </Typography>
      <SelectField
        id="salesperson"
        label="Sales person"
        values={props.config?.salesPerson}
        required
      />
    </Step>
  );
};

export default StepSales;
